/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

var props = {
  delay: {
    type: Number
  },
  destroyOnClose: {
    type: Boolean,
    "default": true
  },
  duration: {
    type: Number
  },
  placement: {
    type: String,
    "default": "top"
  },
  showArrow: {
    type: Boolean,
    "default": true
  },
  theme: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "primary", "success", "danger", "warning", "light"].includes(val);
    }
  }
};

export { props as default };
//# sourceMappingURL=props.mjs.map
